import OrderAdvancedView from './OrderAdvancedView'

export default OrderAdvancedView
